'use client';

import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

const getFeeOptions = (feeOptions) => {
	const filterFees = feeOptions.filter(({ feesHistory }) => feesHistory?.[0]?.productCode);
	return filterFees.map(({ id, feesHistory }) => ({
		key: id,
		value: `${feesHistory[0].productCode.code} ${feesHistory[0].rateCode ? `/ ${feesHistory?.[0]?.rateCode?.code}` : ''}`,
	}));
};

const getFeeValue = (monthlyFee): { key: string; value: string } => {
	if (!monthlyFee?.feesHistory?.length || !monthlyFee?.feesHistory?.[0]?.productCode) return { key: '', value: '' };
	return {
		key: monthlyFee.id,
		value: `${monthlyFee.feesHistory[0].productCode.code} ${monthlyFee.feesHistory[0].rateCode ? `/ ${monthlyFee.feesHistory[0].rateCode.code}` : ''}`,
	};
};

export const ProductRateCodeAutoComplete = ({ id, handleChange, feeOptions, selectedFee, disabled, error }) => (
	<Autocomplete
		className='pca__manualInvoiceForm-productAndRateCodeAutocomplete'
		options={getFeeOptions(feeOptions)}
		value={getFeeValue(selectedFee)}
		freeSolo
		disabled={disabled}
		size='medium'
		isOptionEqualToValue={(option, value) => option.key === value.key}
		getOptionLabel={(option) => {
			if (typeof option === 'string') return '';
			return option.value;
		}}
		renderOption={(props, option) => (
			<li {...props} key={`${id}-${option.key}`}>
				{option.value}
			</li>
		)}
		renderInput={(params) => (
			<TextField
				{...params}
				value={selectedFee?.id || ''}
				inputProps={{ ...params.inputProps, 'data-cy': id }}
				error={error}
			/>
		)}
		onInputChange={(_, __, reason) => {
			if (reason === 'clear') handleChange(null);
		}}
		onChange={(_, value) => {
			if (!value || typeof value === 'string') return;
			const findFee = feeOptions.find((fee) => fee.id === value.key);
			handleChange(findFee);
		}}
	/>
);
